import { render, staticRenderFns } from "./PurchaseOrderDetailList.vue?vue&type=template&id=2a9fbffe&scoped=true"
import script from "./PurchaseOrderDetailList.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderDetailList.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrderDetailList.vue?vue&type=style&index=0&id=2a9fbffe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9fbffe",
  null
  
)

export default component.exports